<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Training</h2>
		</div>
		<div>
			<iframe
				style="border: 1px solid #e0e0e0"
				width="100%"
				height="800"
				:src="$vtrainingurl + '/account/?guid=' + tenantGUID + '&view=admin'"
			>
			</iframe>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			tenantGUID: "6512bd43d9caa6e02c990b0a82652dca"
		};
	},
	mounted: function () {
		this.setGUID();
	},
	methods: {
		setGUID() {
			axios.get("/system/vTraining/tenant/guid?id=" + this.$store.state.principal.tenantId).then((res) => {
				this.tenantGUID = res.data;
			});
		},
	}
};
</script>
